import { sessionDataDec } from "../services/sessionServiceEndDec";

export const RoleCheck = (item) => {
    const { role = [], privilege = [], onlyForUsers = [] } = item;

    const dashboardData = JSON.parse(sessionDataDec("dashboardData") || "{}");
    const currRole = dashboardData.userType;
    const currPrivilege = dashboardData.privileges || [];
    const isApiPartner = dashboardData.isApiPartnerEnabled;

    // API partner → strict filter
    if (isApiPartner) {
        const requiredPrivilege = "STRICT_ACCESS_ONLY";
        return onlyForUsers.includes(requiredPrivilege);
    }    
    
    const hasRole = role.includes("ALL") || role.includes(currRole);
    const hasPrivilege = privilege.some((p) => currPrivilege.includes(p));
   
    return hasRole || hasPrivilege;
};
